theme.modal = {

    // Initialise modals
    init: function() {

        // Open
        $(document).on('click', '[data-modal-fire]', function(event) {
            event.preventDefault()
            let data = $(event.currentTarget).data()
            let $modal = $('[data-modal="'+data.modalFire+'"]')
            if ($modal.length != 0) {
                $('body').addClass('modal--open')
                $modal.removeClass('invisible opacity-0 scale-90')
            }
        })

        // Close
        $(document).on('click', '[data-modal-close]', function(event) {
            event.preventDefault()
            let data = $(event.currentTarget).data()
            let $modal = $('[data-modal="'+data.modalClose+'"]')
            if ($modal.length != 0) {
                $('body').removeClass('modal--open')
                $modal.addClass('invisible opacity-0 scale-90')
            }
        })
        
        // Close : Escape Key
        $(document).on('keyup', function(event) {
            if (event.key === "Escape") {
                $('body').removeClass('modal--open')
                $('[data-modal]').addClass('invisible opacity-0 scale-90')
           }
       })

    }
}

$(function(){
    theme.modal.init()
})